export const NotificationTypeEnum = Object.freeze({
  EMAIL: 'email',
  SMS: 'sms',
  BOTH: 'both',
});

export const ReceiverTypeEnum = Object.freeze({
  PATIENT: 'patient',
  CAREGIVER: 'caregiver',
});
